<template>
  <AccountTableView ref="tableRef" />
</template>

<script>
import AccountTableView from '../../../components/container/AccountTableView.vue';

export default {
  components: { AccountTableView },
};
</script>